import styled from "styled-components";

import { adminFontFamily, adminTokens } from "@pages/AdminDashboard/theme/adminTokens";

const { color } = adminTokens;
// The design's key cap: Medium 11 in a white box, 6px corners, 1px by 6px of padding.
const keyFontSize = "11px";
const keyRadius = 6;
const keyPaddingBlock = 1;
const keyPaddingInline = 6;

// A key the admin presses, named inside running text (KEY-R1, KEY-R2).
export const Key = styled.kbd`
  padding: ${keyPaddingBlock}px ${keyPaddingInline}px;
  border: 1px solid ${color.border};
  border-radius: ${keyRadius}px;
  background-color: ${color.surface};
  color: ${color.navy};
  font-family: ${adminFontFamily.medium};
  font-size: ${keyFontSize};
`;
